const showPsw = document.getElementsByClassName('show-psw');
for(let i of showPsw){
  i.addEventListener('click', function(){
    if(i.nextElementSibling.type == "password"){
      i.nextElementSibling.type = "text";
    }else{
      i.nextElementSibling.type = "password";
    }
  })
}

const tabs = document.getElementsByClassName('modal-tab');
const filters = document.getElementsByClassName('filter-tab');
for(let filter of filters){
  filter.addEventListener('click', function(){
    let name = this.dataset.name;
    let header = document.querySelectorAll('h2.filter-tab[data-name='+name+']')[0];
    for(let f of filters){
      f.classList.remove('active');
    }
    if(header){
      header.classList.add('active');
    }
    for(let tab of tabs){
        tab.classList.add('hidden');
    }
    document.getElementById(name).classList.remove('hidden');
  })
}